goog.provide("shadow.js.shim.module$$mui$material$Popover");
goog.provide("module$shadow_js_shim_module$$mui$material$Popover");
shadow.js.shim.module$$mui$material$Popover = shadow.js.nativeProvides["@mui/material/Popover"] = shadow$bridge("@mui/material/Popover");
module$shadow_js_shim_module$$mui$material$Popover.default = shadow.js.shim.module$$mui$material$Popover;
